// Component
import ButtonNav from "../ButtonNav/ButtonNav"

// CSS
import "./ButtonNavContainer.css"

// Image

import preference from "../../images/profile/profile_preference.svg"
import contactUs from "../../images/profile/profile_contact_us.svg"
import map from "../../images/profile/profile_map.svg"
import { ProfileMenu } from "../../utils/ProfileMenu"


export default function ButtonNavContainer({ onClick }) {

    const clickPreference = () => { }

    const clickService = () => { }

    const clickContactUs = () => {
        document.getElementById("popupGestorTrigger").click();
    }

    const options = [
        {
            id: 3,
            title: "Contacte-nos",
            icon: <img src={contactUs} />,
            action: () => clickContactUs(),
        },

        //{ Bug 266751: Alinhar comportamentos Dashboard / Perfil 

        // {
        //     id: 3,
        //     title: "Atendimento a associados",
        //     icon: <img src={map} />,
        //     action: () => clickService(),
        // },
        // {
        //     id: 2,
        //     title: "Preferências My Montepio",
        //     icon: <img src={preference} />,
        //     action: () => clickPreference(),
        // }
    ];

    return (
        <div className="button-nav-container">
            {options.map((item) => (
                <ButtonNav
                    key={item.id}
                    title={item.title}
                    icon={item.icon}
                    onClick={item.action}
                />
            ))}
        </div>
    );
}
